module.exports = __webpack_public_path__ + "img/1.0dc236c6.jpg";